import {
  IonApp,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import {
  Box,
  Button,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Pagination,
  TextField,
  Stack,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { requestID, baseURL, config } from "../../../common/utils";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WalletLedger from "./WalletLedger";

interface WalletItem {
  user_id: "";
  merchantName: string;
  walletName: string;
  bankName: string;
  accountNumber: "";
  balValue: "";
  debit: "";
  credit: "";
}

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  maxWidth: "800px",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: "10px",
  boxShadow: 24,
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  p: 4,
};

const WalletReport: React.FC = () => {

//function WalletReport() {
  const [open, setOpen] = useState(false);
  const [viewMode, setViewMode] = useState<"walletDetails" | "ledger" | null>(
    null
  );
  const [loading, setLoading] = useState({
    table: false,
    modal: false,
  });
  const [selectedWallet, setSelectedWallet] = useState<WalletItem | null>(null);
  const [wallets, setWallets] = useState<WalletItem[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;

  const handleOpenDetails = (wallet: WalletItem) => {
    setSelectedWallet(wallet);
    setViewMode("walletDetails");
    setOpen(true);
  };

  const handleOpenLedger = (wallet: WalletItem) => {
    setSelectedWallet(wallet);
    setViewMode("ledger");
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setViewMode(null);
    setSelectedWallet(null);
  };

  const fetchWallets = async () => {
    try {
      setLoading((prev) => ({ ...prev, table: true }));
      const payload = { requestID: requestID() };
      const res = await axios.post(
        `${baseURL}wallets/getWalletMaster`,
        payload,
        config
      );
      console.log(res);
      setWallets(res.data.data || []);
    } catch (error) {
      console.error("Error fetching wallet data:", error);
    } finally {
      setLoading((prev) => ({ ...prev, table: false }));
    }
  };

  useEffect(() => {
    fetchWallets();
  }, []);

  const filteredWallets = wallets.filter((item) =>
    `${item.id} ${item.merchantName} ${item.walletName} ${item.bankName} ${item.accountNumber}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const paginatedWallets = filteredWallets.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar>
          <IonTitle>Wallet Report</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent className="ion-padding">
        <Box sx={{ mb: 2 }}>
          <TextField
            label="Search Wallets"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setPage(1);
            }}
            sx={{ mb: 2 }}
          />
        </Box>

        <TableContainer component={Paper} sx={{ maxHeight: "80vh" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {[
                 // "Member No",
                //  "Member Name",
                  "Member Name/Wallet Name",
                  "BankName",
                  "Account No",
                 // "Balance",
                  "Actions",
                ].map((head) => (
                  <TableCell key={head} sx={{ fontWeight: "bold" }}>
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading.table ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : paginatedWallets.length > 0 ? (
                paginatedWallets.map((wallet) => (
                  <TableRow key={wallet.user_id} hover>
                {/*     <TableCell>{wallet.user_id}</TableCell> 
                    <TableCell>{wallet.merchantName}</TableCell>*/}
                    <TableCell>{wallet.walletName}</TableCell>
                    <TableCell>{wallet.bankName}</TableCell>
                    <TableCell>{wallet.accountNumber}</TableCell>
                    {/* <TableCell>N{wallet.balValue}</TableCell> */}
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "4px",
                        }}
                      >
                       {/*  <Tooltip title="View wallet">
                          <IconButton
                            color="primary"
                            onClick={() => handleOpenDetails(wallet)}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip> */}

                        <Tooltip title="View Account Statement">
                           
                          <IconButton
                            color="secondary"
                            onClick={() => handleOpenLedger(wallet)}
                          >
                            <VisibilityIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    {searchTerm
                      ? "No matching wallets found"
                      : "No wallet data available"}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {filteredWallets.length > 0 && (
          <Box display="flex" justifyContent="center" my={2}>
            <Pagination
              count={Math.ceil(filteredWallets.length / rowsPerPage)}
              page={page}
              onChange={(_, value) => setPage(value)}
              color="primary"
              variant="outlined"
              shape="rounded"
            />
          </Box>
        )}

<Modal open={open} onClose={handleClose}>
  <Box sx={modalStyle}>
    {viewMode === "walletDetails" && selectedWallet && (
      <>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Wallet Details
        </Typography>
        <Stack spacing={2}>
         {/*  <Typography><strong>Member No:</strong> {selectedWallet.user_id}</Typography> */}
          <Typography><strong>Merchant Name:</strong> {selectedWallet.merchantName}</Typography>
          <Typography><strong>Wallet Name:</strong> {selectedWallet.walletName}</Typography>
          <Typography><strong>Bank Name:</strong> {selectedWallet.bankName}</Typography>
          <Typography><strong>Account Number:</strong> {selectedWallet.accountNumber}</Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 2,
              mt: 2,
              p: 2,
              backgroundColor: "grey.100",
              borderRadius: 1,
            }}
          >
            <Typography><strong>Total Debit:</strong> N{selectedWallet.debit}</Typography>
            <Typography><strong>Total Credit:</strong> N{selectedWallet.credit}</Typography>
            <Typography><strong>Current Balance:</strong> N{selectedWallet.balValue}</Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button onClick={handleClose} variant="contained" color="primary">
              Close
            </Button>
          </Box>
        </Stack>
      </>
    )}

    {viewMode === "ledger" && selectedWallet && (
      <>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Wallet Ledger
        </Typography>
        <WalletLedger wallet={selectedWallet} />
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button onClick={handleClose} variant="contained" color="primary">
            Close
          </Button>
        </Box>
      </>
    )}
  </Box>
</Modal>

      </IonContent>
    </IonPage>
  );
}

export default WalletReport;
